import { Link, Stack, Typography } from "@mui/material";
import React from "react";
import "./Header.scss";
import strings from "../../assets/string.json";
import Links from "../../assets/contact.json";
import GitHubIcon from "@mui/icons-material/GitHub";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import HeroBackground from "./HeroBackground";

export default function Header({ languageState }) {
  const socialLinks = [
    {
      href: Links.Githib,
      label: "GitHub",
      icon: <GitHubIcon className="icon" />,
    },
    {
      href: Links.Linkedin,
      label: "LinkedIn",
      icon: <LinkedInIcon className="icon" />,
    },
    {
      href: Links.X,
      label: "X",
      icon: <XIcon className="icon" />,
    },
  ];

  return (
    <Stack id="home" component="header">
      <HeroBackground />
      <Stack className="hero-content">
        <Typography variant="tag" className="hero-eyebrow">
          {strings.hero.welcome[languageState]}
        </Typography>

        <Typography id="myname" variant="bigTitle" className="hero-name">
          {strings.hero.name[languageState]}
        </Typography>

        <Typography id="jobtitle" variant="subTitle" className="hero-role">
          {strings.hero.job[languageState]}
        </Typography>

        <Typography variant="normalTxt" className="hero-description">
          {strings.hero.description[languageState]}
        </Typography>

        <Typography variant="smallTxt" className="hero-location">
          {strings.hero.location[languageState]}
        </Typography>

        <Stack className="header-btn">
          <a className="btn-primary" href="#work">
            {strings.hero.hireBtn[languageState]}
          </a>
          <a className="btn-outline" href="#contact">
            {strings.hero.contactBtn[languageState]}
          </a>
        </Stack>

        <Stack className="links">
          {socialLinks.map((link) => (
            <Link
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.label}
            >
              {link.icon}
            </Link>
          ))}
        </Stack>

        <Typography variant="smallTxt" className="hero-tech-line">
          {strings.hero.techLine[languageState]}
        </Typography>
      </Stack>
    </Stack>
  );
}
